import { render, staticRenderFns } from "./admin.smartwatch.edit.page.vue?vue&type=template&id=8629e95c&scoped=true&"
import script from "./admin.smartwatch.edit.page.vue?vue&type=script&lang=js&"
export * from "./admin.smartwatch.edit.page.vue?vue&type=script&lang=js&"
import style0 from "./admin.smartwatch.edit.page.vue?vue&type=style&index=0&id=8629e95c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8629e95c",
  null
  
)

export default component.exports